import { Row } from '@busybusy/webapp-react-ui';
import { IChildrenProps } from 'types/ChildrenProps';
import './Main.scss';

const Main = ({ children }: IChildrenProps) => <Row className="main">{children}</Row>;

export default Main;
